module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/app/empty-layout/empty-layout.component.html
// module id = ../../../../../src/app/empty-layout/empty-layout.component.html
// module chunks = main